import React, { useState, useEffect } from "react";
import { Button, Popover, Box, TextField } from "@mui/material";

import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import { format, parse, isValid } from "date-fns";
import { fr, enGB } from "date-fns/locale";

const DispensingLanguage = JSON.parse(
  localStorage.getItem("DispensingLanguage"),
);
const lan = localStorage.getItem("LangCode");
const menukey = "receive";

const DatePickerModal = ({
  handleClose,
  open,
  addDatePicker,
  reload,
  ExpiryDate,
  anchorEl,
  ...props
}) => {
  let currExpDate = ExpiryDate
    ? format(parse(ExpiryDate, "dd/MM/yyyy", new Date()), "yyyy-MM-dd")
    : format(new Date(), "yyyy-MM-dd");

  const [selectedProducts, setselectedProducts] = useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedDefaultDate, setSelectedDefaultDate] = useState(new Date());

  setInterval(myTimer, 500);

  function myTimer() {
    if (reload === 0 && selectedDefaultDate != currExpDate) {
      setSelectedDate(currExpDate);
      setSelectedDefaultDate(currExpDate);
      reload = 1;
    }
  }

  const SaveSelectedProducts = () => {
    let validCurrDate = selectedDate ? new Date(selectedDate) : new Date();
    if (!isValid(validCurrDate)) {
      validCurrDate = new Date();
    }

    setselectedProducts(validCurrDate);
    setSelectedDefaultDate(new Date());
  };

  useEffect(() => {
    addDatePicker(selectedProducts);
  }, [selectedProducts]);

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleModalColse = () => {
    handleClose("DatePickerClose");
    setSelectedDefaultDate(new Date());
  };

  return (
    <Popover
      open={open}
      anchorReference="anchorPosition"
      anchorPosition={anchorEl}
      onClose={() => handleModalColse()}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
    >
      <Box>
        <Box display="flex" justifyContent="center">
          <LocalizationProvider
            dateAdapter={AdapterDateFns}
            adapterLocale={lan === "en_GB" ? enGB : fr}
          >
            <StaticDatePicker
              displayStaticWrapperAs="desktop"
              value={selectedDate}
              onChange={handleDateChange}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, p: 1 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={SaveSelectedProducts}
          >
            {DispensingLanguage[lan][menukey]["ADD"]}
          </Button>
          <Button variant="contained" color="gray" onClick={() => handleModalColse()}>
            {DispensingLanguage[lan][menukey]["CANCEL"]}
          </Button>
        </Box>
      </Box>
    </Popover>
  );
};

export default DatePickerModal;
